<div class="p-container flex justify-center">
  <div class="min-h-screen max-w-6xl w-full text-foreground shadow-lg border rounded-3xl px-5 py-6">
    <!-- Header -->

    <ng-container *ngIf="isLoading; else content">
      <!-- Loader title -->
      <div class="text-center text-gray-600 mb-4 font-medium">
        Calculating your pre-assessment score… please wait
      </div>
      <!-- Header shimmer -->
      <div class="skeleton h-6 w-48 mb-6"></div>

      <!-- Circle shimmer -->
      <div class="flex justify-center mt-6">
        <div class="skeleton w-56 h-56 rounded-full"></div>
      </div>

      <!-- Text shimmer -->
      <div class="skeleton h-4 w-64 mx-auto mt-6"></div>
      <div class="skeleton h-4 w-40 mx-auto mt-3"></div>

      <!-- Cards shimmer -->
      <div class="mt-10 space-y-4">
        <div class="skeleton h-24 w-full"></div>
        <div class="skeleton h-24 w-full"></div>
        <div class="skeleton h-24 w-full"></div>
        <div class="skeleton h-24 w-full"></div>
      </div>
    </ng-container>

    <ng-template #content>
      <div class="flex items-center mb-6">
        <h2 class="text-2xl font-semibold text-center">Pre-Assessment Score</h2>
      </div>

      <!-- Score Circle -->
      <div class="flex flex-col items-center mt-6">
        <div
          class="relative w-56 h-56 flex items-center justify-center rounded-full bg-card shadow-xl border-8 border-green-400"
        >
          <div class="text-center">
            <h1 class="text-5xl font-bold text-green-500">
              {{ scoreData?.total_score }}
            </h1>
            <p class="text-muted-foreground text-lg">out of {{ scoreData?.max_score }}</p>
          </div>
        </div>

        <p class="mt-6 text-lg text-center max-w-xs font-medium">
          There's room for improvement. Let's focus on building better habits.
        </p>

        <p class="text-sm text-muted-foreground mt-2">Assessment Date: {{ preAssessment?.date }}</p>
      </div>

      <!-- Overview Section -->
      <div class="mt-10">
        <h3 class="text-lg font-semibold mb-4">Assessment Overview</h3>

        <!-- BMI -->
        <div class="bg-card p-5 rounded-2xl mb-4 shadow-md border text-foreground">
          <div class="flex justify-between mb-2">
            <h4 class="font-medium">BMI (Body Mass Index)</h4>
            <span class="font-semibold">{{ scoreData?.bmi_score }}/25</span>
          </div>

          <div class="w-full bg-gray-200 rounded-full h-2">
            <div
              class="bg-red-500 h-2 rounded-full transition-all duration-500"
              [style.width.%]="(scoreData?.bmi_score / 25) * 100"
            ></div>
          </div>

          <p class="text-sm text-muted-foreground mt-2">Needs Improvement</p>
        </div>

        <!-- Water -->
        <div class="bg-card p-5 rounded-2xl mb-4 shadow-md border">
          <div class="flex justify-between mb-2">
            <h4 class="font-medium">Water Intake</h4>
            <span class="font-semibold">{{ scoreData?.water_score }}/25</span>
          </div>

          <div class="w-full bg-gray-200 rounded-full h-2">
            <div
              class="bg-blue-500 h-2 rounded-full transition-all duration-500"
              [style.width.%]="(scoreData?.water_score / 25) * 100"
            ></div>
          </div>

          <p class="text-sm text-muted-foreground mt-2">Hydration Level</p>
        </div>

        <!-- Activity -->
        <div class="bg-card p-5 rounded-2xl mb-4 shadow-md border">
          <div class="flex justify-between mb-2">
            <h4 class="font-medium">Physical Activity</h4>
            <span class="font-semibold">{{ scoreData?.activity_score }}/25</span>
          </div>

          <div class="w-full bg-gray-200 rounded-full h-2">
            <div
              class="bg-green-500 h-2 rounded-full transition-all duration-500"
              [style.width.%]="(scoreData?.activity_score / 25) * 100"
            ></div>
          </div>

          <p class="text-sm text-muted-foreground mt-2">Moderate Activity</p>
        </div>

        <!-- Sleep -->
        <div class="bg-card p-5 rounded-2xl mb-6 shadow-md border">
          <div class="flex justify-between mb-2">
            <h4 class="font-medium">Sleep Quality</h4>
            <span class="font-semibold">{{ scoreData?.sleep_score }}/25</span>
          </div>

          <div class="w-full bg-gray-200 rounded-full h-2">
            <div
              class="bg-yellow-500 h-2 rounded-full transition-all duration-500"
              [style.width.%]="(scoreData?.sleep_score / 25) * 100"
            ></div>
          </div>

          <p class="text-sm text-muted-foreground mt-2">Fair Sleep</p>
        </div>
      </div>

      <!-- Proceed Button -->
      <div class="mt-10 pb-10 flex gap-5 flex-col">
        <button
          *ngIf="isBookingAllowed"
          (click)="proceedToAppointment()"
          class="w-full bg-primary hover:bg-primary/90 text-primary-foreground py-3 rounded-full text-lg font-semibold shadow-lg transition-all"
        >
          Proceed to Book Appointment →
        </button>

        <button
          (click)="goToDashboard()"
          class="w-full bg-primary hover:bg-primary/90 text-primary-foreground py-3 rounded-full text-lg font-semibold shadow-lg transition-all"
        >
          Go to Dashboard →
        </button>
      </div>
    </ng-template>
  </div>
</div>

<!-- <patient-pre-assesment></patient-pre-assesment> -->
